import { useLocation } from 'react-router-dom'
import { findNavEntry } from './navModel'

export interface Crumb {
  label: string
  path?: string
}

/**
 * Derives the breadcrumb trail from the nav model and the current route, so a
 * new surface gets a correct trail by being added to `navModel` — no per-page
 * breadcrumb wiring to forget.
 *
 * A path deeper than its nav entry (e.g. `/data-entry/SupplierInvoice`) appends
 * the extra segment as a final crumb, which is how the table-name and
 * report-name routes get a sensible trail.
 */
export function useBreadcrumbs(): Crumb[] {
  const { pathname } = useLocation()
  const match = findNavEntry(pathname)
  if (!match) return []

  const crumbs: Crumb[] = []
  if (match.section) crumbs.push({ label: match.section })
  crumbs.push({ label: match.entry.label, path: match.entry.path })

  const base = match.entry.path ?? ''
  if (pathname.length > base.length) {
    const rest = pathname.slice(base.length).replace(/^\//, '')
    if (rest) {
      // Only the first extra segment; deeper nesting would need its own model.
      crumbs.push({ label: decodeURIComponent(rest.split('/')[0]) })
    }
  }

  return crumbs
}
